import React from "react";
import headerIcon from "../../../../assets/icons/report-core-competencies-icon.svg";
import CoreCompetenciesRadar from "./components/CoreCompetenciesRadar";
import { CompetencyScores } from "../../types";

/**
 * Props interface that expects the new object shape
 * (potentially undefined if data is missing).
 */
interface CoreCompetenciesProps {
  competencies?: CompetencyScores;
}

const CoreCompetencies: React.FC<CoreCompetenciesProps> = ({
  competencies,
}) => {
  // 1) Convert the object-based `competencies` into an array for the radar chart.
  //    If `competencies` is undefined, we fall back to an empty array.
  const radarData = competencies
    ? [
        {
          name: "Structured Thinking",
          score: competencies.structuredThinking.score,
          maxScore: competencies.structuredThinking.maxScore,
        },
        {
          name: "Prioritization",
          score: competencies.prioritization.score,
          maxScore: competencies.prioritization.maxScore,
        },
        {
          name: "Communication",
          score: competencies.communication.score,
          maxScore: competencies.communication.maxScore,
        },
        {
          name: "Business Acumen",
          score: competencies.businessAcumen.score,
          maxScore: competencies.businessAcumen.maxScore,
        },
      ]
    : [];

  return (
    <div
      className="bg-white rounded-lg shadow-sm h-full flex flex-col overflow-hidden"
      style={{ border: "1px solid #E6E8EB" }}
    >
      {/* Header Section */}
      <div className="bg-[#F5F6F7] p-4 rounded-t-lg">
        <div className="flex items-center gap-2">
          <img
            src={headerIcon}
            className="w-6 h-6"
            style={{
              filter:
                "invert(27%) sepia(93%) saturate(1862%) hue-rotate(227deg) brightness(89%) contrast(98%)",
            }}
            alt="Core Icon"
          />
          <h2 className="text-xl font-semibold text-[#1F2024]">
            Core Competencies
          </h2>
        </div>
      </div>

      {/* Radar Chart Container */}
      <div className="flex-1 overflow-auto">
        <div className="w-full h-full p-4 flex items-center justify-center">
          <CoreCompetenciesRadar data={radarData} />
        </div>
      </div>
    </div>
  );
};

export default CoreCompetencies;
